import { AdditionalEquipment } from './AdditionalEquipment'
import { DriverDiscount } from './DriverDiscount'
import { DriverInfo } from './DriverInfo'
import { DriversList } from './DriversList'
import { ParkingMode } from './ParkingMode'
import { PeriodInsurance } from './PeriodInsurance'
import { SpecificAdjustments } from './SpecificAdjustments'
import { Territory } from './Territory'

export const CorrectionsStep = () => {
  return (
    <>
      <Territory />
      <ParkingMode />
      <DriverDiscount />
      <SpecificAdjustments />
      <PeriodInsurance />
      <AdditionalEquipment />
      <DriverInfo />
      <DriversList />
    </>
  )
}
